import { SprintMutationResult, useSprintMutation, useSprintQueryClient, ValidationResult } from "sprint-common-web";

import { ValidateIfAbleToDeprecateCloudAssetRequest } from "../../../../../../../common/api/master-api/assets/deprecate/validate/ValidateIfAbleToDeprecateCloudAssetRequest";
import { useAssetsApi } from "../../../../../../../common/api/master-api/assets/useAssetsApi";
import { CloudAssetQueryKey } from "../../../../common/CloudAssetQueryKey";

interface DeprecateCloudAssetParams {
    assetId?: string;
}

interface UseDeprecateCloudAsset {
    deprecateCloudAsset: SprintMutationResult<DeprecateCloudAssetParams>;
    validateDeprecationCloudAsset: SprintMutationResult<ValidateIfAbleToDeprecateCloudAssetRequest, ValidationResult>;
}

export const useDeprecateCloudAsset = ({ invalidationKey }: { invalidationKey?: string }): UseDeprecateCloudAsset => {
    const { deprecateCloudAsset, validateIfAbleToDeprecateCloudAsset } = useAssetsApi();
    const sprintQueryClient = useSprintQueryClient();

    const deprecate = useSprintMutation<DeprecateCloudAssetParams>({
        mutationFn: async ({ assetId }: DeprecateCloudAssetParams) => {
            if (!assetId) {
                throw new Error("Asset ID is required to deprecate a cloud asset.");
            }

            await deprecateCloudAsset({ assetId });
        },
        onSettled: async () => {
            await sprintQueryClient.invalidateQueries({
                queryKey: [CloudAssetQueryKey.CloudAssetDetails, invalidationKey]
            });
        }
    });

    const validate = useSprintMutation<ValidateIfAbleToDeprecateCloudAssetRequest, ValidationResult>({
        mutationFn: async ({ assetId }): Promise<ValidationResult> => {
            if (!assetId) {
                throw new Error("Asset ID is required to deprecate a cloud asset.");
            }

            return validateIfAbleToDeprecateCloudAsset({ assetId });
        }
    });

    return { deprecateCloudAsset: deprecate, validateDeprecationCloudAsset: validate };
};
